import { render, staticRenderFns } from "./SummaryButton.vue?vue&type=template&id=42920ca2&scoped=true"
import script from "./SummaryButton.vue?vue&type=script&lang=js"
export * from "./SummaryButton.vue?vue&type=script&lang=js"
import style0 from "./SummaryButton.vue?vue&type=style&index=0&id=42920ca2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42920ca2",
  null
  
)

export default component.exports